import { useNavigate } from 'react-router-dom';
import { AbsoluteCenter, Center } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { Trans } from 'react-i18next';
import { t } from 'i18next';

const FanBuddyChatBotSplashPage = () => {
  const navigate = useNavigate();
  setTimeout(() => {
    navigate('/fan-buddy/mbti');
  }, 1500);

  return (
    <AbsoluteCenter style={{ padding: '0 24px', width: '100%' }}>
      <Center flexDirection={'column'}>
        <img
          width={'172px'}
          height={'172px'}
          src={'/assets/backgrounds/fan-buddy/Mage Light Skin Tone.png'}
          alt={'wizard'}
        />
        <div className="pt-[22px]">
          <motion.div
            initial={{ opacity: 0, y: -10 }} // 위에서 아래로 이동
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h1 className="text-[20px] font-bold leading-[24px] text-center text-text-main-lv1 whitespace-pre-wrap">
              <Trans
                i18nKey="FanBuddyChatBotSplash.title"
                components={{
                  span: <span className="text-primary-light dark:text-primary-dark" />
                }}
              />
            </h1>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: -10 }} // 위에서 아래로 이동
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }} // 0.5초 딜레이 추가
          >
            <p className="text-[15px] font-medium leading-[18px] text-center text-text-main-lv4 pt-[14px] whitespace-pre-wrap">
              {t('FanBuddyChatBotSplash.description')}
            </p>
          </motion.div>
        </div>
      </Center>
    </AbsoluteCenter>
  );
};

export default FanBuddyChatBotSplashPage;
